import ScreensaverLayout from '../../components/pages/ScreensaverFlipped';
import themes from '../../themes';

export default function Screensaver() {
  return <ScreensaverLayout station={'ziehen'} theme={themes.ziehen} rotations={{ root: 270 }}  />;
}
